<template>
  <div style="background: #fff">
    <div class="login_concat">
      <VuiIco class="ico-close ibang-close" @click.native="$router.push({ name: 'Home' })"></VuiIco>
      <div class="tips_top">
        <p>未来法学院期待您的加入</p>
      </div>
      <div class="login_concat_card">
        <p class="login_concat_info">{{drainageValue.toolTips}}</p>
        <img class="login_concat_avatar" :src="drainageValue.orangePicture"/>
        <p class="login_concat_name">{{drainageValue.orangeName}}</p>
        <p class="login_concat_value">微信号：{{drainageValue.orangeWeChat}}</p>
        <img class="login_concat_qrcode" :src="drainageValue.weChatCode"/>
        <p class="login_concat_more">微信扫描二维码添加</p>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState('app', ['systemConfig']),
    drainageValue () {
      return this.systemConfig.weChatOrange || {}
    },
  },
}
</script>
<style lang="scss" scoped>
.login_concat {
  text-align: center;
  width: 400px;
  height: 100vh;
  padding-top: 46px;
  margin: auto;
  .ico-close {
    position: absolute;
    top: 20px;
    right: 20px;
  }
  .tips_top {
    height: 44px;
    background: #fff9c4;
    margin: 0 16px 16px;
    font-size: 12px;
    padding: 14px;
    line-height: 1.5;
  }
  .login_concat_img {
    width: 100%;
  }
  .tips_bottom {
    margin-top: 16px;
    color: #959595;
  }
  .login_concat_card {
    width: 300px;
    margin: 100px auto;
    border-radius: 4px;
    text-align: center;
    border-radius: 15px;
    background: #fff;
    padding: 24px 48px;
    line-height: 24px;
    box-shadow: 0 0 6px #ddd;
    .login_concat_info {
      margin-bottom: 20px;
    }
    .login_concat_avatar {
      width: 56px;
      height: 56px;
      margin-bottom: 10px;
    }
    .login_concat_value {
      color: #959595;
      margin-bottom: 10px;
    }
    .login_concat_qrcode {
      height: 100px;
      width: 100px;
      margin-bottom: 10px;
    }
    .login_concat_more {
      color: #959595;
      font-size: 14px;
    }
  }
}
</style>
